import { render, staticRenderFns } from "./projection-weekly-plan.vue?vue&type=template&id=47c152b4&scoped=true"
import script from "./projection-weekly-plan.vue?vue&type=script&lang=js"
export * from "./projection-weekly-plan.vue?vue&type=script&lang=js"
import style0 from "./projection-weekly-plan.vue?vue&type=style&index=0&id=47c152b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c152b4",
  null
  
)

export default component.exports